import { useEffect, useState, cloneElement } from 'react';

import Trigger from 'rc-trigger';
import classNames from 'classnames';
import { POPOVER_CLASS, POPOVER_OVERLAY_CLASS } from '@sede-x/shell-ds-react-base';

import * as Styled from './Popover.styles';
import { IPopoverProps } from './Popover.types';
import placements from './Popover.consts';

const PopoverComponent = ({
  className,
  popupClassName,
  popup,
  arrow,
  children,
  action = 'click',
  defaultPopupVisible = false,
  onPopupVisibleChange,
  popupVisible,
  ...rest
}: IPopoverProps) => {
  const [isPopupVisible, setIsPopupVisible] = useState(defaultPopupVisible || popupVisible);

  const isChildString = typeof popup === 'string';

  const Popup = () => (
    <>
      {arrow && <Styled.PopoverOverlayArrow className={`${POPOVER_CLASS}-arrow`} />}
      <Styled.PopoverOverlay padded={isChildString}>{popup}</Styled.PopoverOverlay>
    </>
  );

  const handleOnClick = (visible: boolean) => {
    setIsPopupVisible(!isPopupVisible);

    if (onPopupVisibleChange) {
      onPopupVisibleChange(visible);
    }
  };

  useEffect(() => {
    const close = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsPopupVisible(false);
      }
    };

    window.addEventListener('keydown', close);

    return () => window.removeEventListener('keydown', close);
  }, []);

  useEffect(() => {
    setIsPopupVisible(popupVisible);
  }, [popupVisible]);

  return (
    <Trigger
      popupClassName={classNames(POPOVER_OVERLAY_CLASS, popupClassName, className, {
        [`${POPOVER_CLASS}-show-arrow`]: arrow,
      })}
      action={action}
      builtinPlacements={placements}
      popupPlacement="bottomLeft"
      onPopupVisibleChange={handleOnClick}
      {...rest}
      prefixCls={POPOVER_CLASS}
      popup={<Popup />}
      popupVisible={isPopupVisible}
    >
      {cloneElement(children, { 'aria-expanded': isPopupVisible })}
    </Trigger>
  );
};

const Popover = Styled.Popover(PopoverComponent, POPOVER_CLASS);

export default Popover;
